/* eslint-disable react/no-unused-prop-types */
import * as React from 'react';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { AppLink } from 'mydish-ui-util';
import '../css/buttons.sass';
import style2object from '../utils/style-object';

interface AnchorProps {
  name?: string;
  id: string;
  children: ReactNode;
  focus?: boolean;
  download?: string;
  style?: string;
  theme?: 'night' | 'day';
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  disabled?: boolean;
  forward?: boolean;
  backward?: boolean;
  type?: 'primary' | 'secondary';
  tabIndex?: number;
  displayAs?: 'link' | 'button';
  color?: 'water' | 'blaze' | 'marshmallow' | 'coal';
  ghost?: boolean;
  frosty?: boolean;
  smol?: boolean;
  spa?: boolean;
  history?: any;
  onClick?: Function;
  rel?: string;
  removeContainerSpan?: boolean;
  title?: string;
  arialabel?: string;
}

export default function Anchor(props: AnchorProps) {
  const {
    type = 'primary',
    theme = 'day',
    color = 'water',
    displayAs = 'link'
  } = props;

  const history = useHistory();

  const isSecondaryButton = type !== 'primary' && displayAs === 'button';
  let className = `${type} ${theme}`;
  if (displayAs === 'button') {
    className = `button cta ${color} filled ${theme}`;
    if (props.ghost || isSecondaryButton) {
      className = `${className.replace('filled', 'ghost')}`;
      if (props.frosty || isSecondaryButton) {
        className = `${className} frosty`;
      }
    }
    if (props.smol) {
      className = `${className} smol`;
    }
  }
  if (displayAs === 'link' && (props.forward || props.backward)) {
    className = `${className} arrow-link`;
  }
  if (props.disabled) {
    className = `${className} disabled`;
  }

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <AppLink
        disabled={props.disabled}
        id={props.id}
        rel={props.rel}
        style={props.style ? style2object(props.style) : {}}
        href={props.href}
        target={props.target}
        className={`${className}${props.spa && history ? ' spa' : ''}`}
        download={props.download}
        tabIndex={props.tabIndex}
        arialabel={props.arialabel ? props.arialabel : undefined}
        title={props.title ? props.title : undefined}
        onClick={
          (props.spa && history) || props.onClick ? props.onClick : undefined
        }
        key={props.id ? props.id : undefined}
      >
        {displayAs === 'link' && props.backward && (
          <img alt="" className="arrow-img backward" />
        )}
        {props.removeContainerSpan ? (
          props.children
        ) : (
          <span>{props.children}</span>
        )}
        {displayAs === 'link' && props.forward && (
          <img alt="" className="arrow-img forward" />
        )}
      </AppLink>
    </>
  );
}
